import React from "react";

const InfoSection = () => {
  return (
    <>
      <section className="info section">
        <div className="info_deco">
          <div className="info_deco-wrapper">
            <picture>
              <source
                data-srcset="img/banners/leaf--left.webp"
                srcSet="img/banners/leaf--left.webp"
                type="image/webp"
              />
              <img
                className="lazy leaf leaf--left"
                data-src="img/banners/leaf--left.png"
                src="img/banners/leaf--left.png"
                alt="deco"
              />
            </picture>
          </div>
          <div className="info_deco-wrapper">
            <picture>
              <source
                data-srcset="img/banners/leaf--right.webp"
                srcSet="img/banners/leaf--right.webp"
                type="image/webp"
              />
              <img
                className="lazy leaf leaf--right"
                data-src="img/banners/leaf--right.png"
                src="img/banners/leaf--right.png"
                alt="deco"
              />
            </picture>
          </div>
        </div>
        <div className="info_highlight">
          <span className="underlay underlay--left">
            <span className="underlay_circle underlay_circle--accent" />{" "}
          </span>
          <span className="underlay underlay--right">
            <span className="underlay_circle underlay_circle--small underlay_circle--green" />{" "}
            <span className="underlay_circle underlay_circle--big underlay_circle--green" />
          </span>
        </div>
        <div className="container">
          <div className="info_content d-flex flex-column align-items-center">
            <span className="info_content-logo">
              <svg
                width={48}
                height={45}
                viewBox="0 0 48 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#infoLogo)">
                  <circle cx="23.5" cy="23.4998" r="17.5" fill="#EFC368" />
                  <path
                    d="M9.79512 42.7418V42.7418C9.34023 42.4033 9.31895 41.6825 9.74864 41.1504L20.897 27.3735L21.6772 27.954L11.3571 42.3414C10.9578 42.9017 10.25 43.0802 9.79512 42.7418Z"
                    fill="#214842"
                  />
                  <path
                    d="M26.6771 42.8479C24.3476 41.406 22.6473 39.3633 21.68 36.619C21.6593 36.5586 21.6359 36.5018 21.6151 36.4414C21.4922 39.036 20.3226 40.6907 20.2435 42.0699C19.132 40.0735 18.4588 38.1106 18.4647 36.206C18.1821 36.2953 17.9437 36.5019 17.8208 36.958C17.3874 35.131 17.6447 32.9512 18.3642 30.5317C18.3464 30.5407 18.3321 30.5524 18.317 30.5578C16.2065 31.901 14.1964 32.7376 12.3296 32.8201C12.7376 32.5789 12.8705 32.2927 12.875 31.9938C11.0458 32.5244 8.97337 32.4184 6.74791 31.9002C8.04923 31.4476 9.32012 29.8636 11.7803 29.0303C11.6909 29.0245 11.5988 29.0222 11.5182 29.0119C8.64916 28.8206 6.24349 27.758 4.23021 25.933C4.69937 26.0793 5.11342 26.0499 5.44359 25.7948C1.69403 23.2492 0.824471 20.6681 0.188852 18.0841C0.246001 18.1328 0.303978 18.1877 0.364647 18.239C2.42593 19.949 7.42129 20.651 12.0076 22.6794C11.9954 22.659 11.9796 22.6359 11.9709 22.6182C8.85487 17.65 8.34457 13.0834 9.54543 8.78741C9.58318 9.21335 9.74327 9.53553 10.0257 9.75395C11.6092 4.78897 13.794 2.1021 16.3564 0.847511C14.6956 3.40296 20.6028 11.3757 20.0354 18.9763C20.067 18.905 20.0933 18.8408 20.1285 18.7722C21.8813 14.7689 24.9437 11.1591 29.0134 7.86035C28.3949 8.82752 28.0996 9.53433 28.39 10.3354C31.404 6.98018 34.6553 4.90665 38.1701 4.24101C38.4991 7.80318 37.4021 11.5 35.0076 15.3221C35.8577 15.3804 36.4557 14.9017 37.2149 14.0407C35.1295 18.9466 32.4473 22.9381 29.0008 25.7322C29.1119 25.6872 29.2212 25.652 29.3359 25.6097C29.3421 25.6088 29.3448 25.6052 29.3537 25.6007C36.0383 23.3432 44.4319 26.1635 47.0271 24.609L47.0298 24.6054C47.1919 24.5148 47.3285 24.3994 47.444 24.2681C46.9443 27.0771 44.9637 29.9178 40.6276 32.8085C40.9181 33.0162 41.2754 33.084 41.6891 33.0038C37.8727 35.3512 33.3229 36.116 27.6566 34.4662C27.7021 34.5229 27.7477 34.5796 27.7924 34.6301C31.0172 38.5605 33.0746 43.2124 35.3315 44.5604C32.6759 44.6643 29.9551 44.5399 26.4711 41.6346C26.3186 42.0347 26.4036 42.4346 26.6771 42.8479Z"
                    fill="#258F67"
                  />
                  <path
                    d="M21.6964 27.3339C21.6964 27.3339 16.6815 25.0813 12.6419 22.5125C9.405 17.4567 8.82341 12.8418 9.98562 8.52346C10.0299 8.95377 10.1971 9.28105 10.4873 9.50533C12.0295 4.51719 14.2143 1.83603 16.8028 0.605255C16.8064 0.60798 7.27498 14.1519 21.6964 27.3339Z"
                    fill="#214842"
                  />
                  <path
                    d="M20.7347 26.7685C20.7347 26.7685 18.8112 24.2889 20.2761 18.3905C22.0786 14.3957 25.1468 10.758 29.1883 7.40349C28.563 8.37328 28.2585 9.07826 28.5221 9.86229C31.5371 6.47721 34.7524 4.352 38.1907 3.61065C30.819 11.8745 24.022 19.9355 20.7347 26.7685Z"
                    fill="#214842"
                  />
                  <path
                    d="M46.9734 24.4342C38.3251 31.4347 29.6485 31.3625 20.9666 27.3752C22.7954 28.1005 26.1505 27.0664 29.4339 25.6238C29.44 25.6229 29.4427 25.6193 29.4516 25.6147C36.1028 23.294 44.3824 26.0159 46.9734 24.4342Z"
                    fill="#214842"
                  />
                  <path
                    d="M35.7432 43.9906C28.1977 39.4093 22.5531 34.0408 20.9998 26.9998C20.9998 26.9998 24.4082 31.2641 28.0546 34.2607C31.3346 38.117 33.4955 42.6236 35.7432 43.9906Z"
                    fill="#214842"
                  />
                  <path
                    d="M20.3668 41.3979C19.9237 36.5216 20.2623 31.7313 21.1995 26.9998C21.389 30.1599 21.57 33.3522 21.8533 36.069C21.8345 36.0107 21.8131 35.9559 21.7944 35.8976C21.6233 38.4267 20.4668 40.0586 20.3668 41.3979Z"
                    fill="#214842"
                  />
                  <path
                    d="M18.8106 30.5696C16.6844 31.8631 14.6463 32.6483 12.7329 32.6764C13.1445 32.445 13.2725 32.1601 13.2683 31.8585C11.4067 32.3402 9.27681 32.172 6.97768 31.5834C12.1204 30.7173 16.9056 29.3275 21.2743 27.331C20.976 28.0954 19.9814 29.3077 18.8106 30.5696Z"
                    fill="#214842"
                  />
                  <path
                    d="M20.9696 27.2397C20.732 27.2913 15.5252 28.3696 11.6631 29.0039C8.78877 28.8184 6.38068 27.7577 4.3675 25.9313C4.83726 26.0771 5.25222 26.0465 5.58362 25.7899C1.83231 23.2444 0.966829 20.6567 0.335772 18.0657C0.392925 18.1144 0.450895 18.1693 0.51157 18.2206C6.50769 23.538 13.1637 27.0346 20.9696 27.2397Z"
                    fill="#214842"
                  />
                  <path
                    d="M22.2931 28.0032C21.7944 28.665 20.8543 28.7971 20.1924 28.2984C19.5306 27.7997 19.3985 26.8595 19.8972 26.1977C20.3959 25.5359 21.336 25.4038 21.9979 25.9025C22.6597 26.4012 22.7918 27.3413 22.2931 28.0032Z"
                    fill="#214842"
                  />
                </g>
                <defs>
                  <clipPath id="infoLogo">
                    <rect width={48} height={45} fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <h2 className="info_content-header">
              Our doctors recommend the best THC to CBD ratio to look for in a
              marijuana strain and suggest the recommended dosage and route of
              administration
            </h2>
          </div>
        </div>
      </section>
    </>
  );
};

export default InfoSection;
